import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("tp_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("tp_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("tp_token", data.token);
    // re-fetch full profile with permissions
    const me = await api.get("/auth/me");
    // password_change_required flag comes from login response, not /me
    setUser({ ...me.data, password_change_required: !!data.user?.password_change_required });
    return data;
  };

  const changePassword = async (current_password, new_password) => {
    await api.post("/auth/change-password", { current_password, new_password });
    setUser((u) => (u ? { ...u, password_change_required: false } : u));
  };

  const logout = () => {
    localStorage.removeItem("tp_token");
    setUser(null);
    window.location.href = "/login";
  };

  return <AuthCtx.Provider value={{ user, loading, login, logout, changePassword }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
